import React from 'react';
import { Field } from 'react-final-form';

interface GenericFieldProps {
  children: React.ReactNode;
  defaultValue?: string;
  name: string;
}

/**
 * This component is builded for uncontrolled element.
 * Final Form only considers registered fields when calculating pristine/dirty.
 * https://github.com/final-form/final-form/issues/169#issuecomment-430939734
 * Usually for event-tracking purpose.
 */
export default function GenericField({ children, defaultValue, name }: GenericFieldProps) {
  return (
    <Field name={name} defaultValue={defaultValue}>
      {() => children}
    </Field>
  );
}
